import React from 'react';
import { Mail, Phone, MapPin, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import { navigation, contactInfo } from '../../data';

const Footer = () => {
  return (
    <footer className="bg-[var(--brand)] text-white pt-16 pb-8 border-t border-white/10 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6">
            <img 
              src="https://assets.auxodev.dk/assets/f3440563-2549-4ae9-b8e8-fd20a3984669/f8d1e252-a8ac-4976-b227-83d6c75463a6.png" 
              alt="Golf4Life Logo" 
              className="h-14 md:h-20 w-auto object-contain shrink-0"
            />
            <p className="text-sm leading-relaxed text-white">
              Longstay golfophold i Cádiz og Costa de la Luz med lejlighed, fri golf og socialt fællesskab.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/golf4life.dk/" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors" aria-label="Følg os på Facebook">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-medium mb-6 uppercase tracking-wider text-sm">Hurtige links</h3>
            <ul className="space-y-4">
              {navigation.map((item) => {
                const isExternal = item.href.startsWith('http');
                const isHash = item.href.includes('#');

                if (isHash && !isExternal) {
                  return (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm text-white hover:text-white transition-colors">
                        {item.name}
                      </a>
                    </li>
                  );
                }

                return (
                  <li key={item.name}>
                    <Link to={item.href} className="text-sm text-white hover:text-white transition-colors">
                      {item.name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-medium mb-6 uppercase tracking-wider text-sm">Kontakt os</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-white/50 shrink-0" />
                <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="text-sm text-white hover:text-white transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-white/50 shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-sm text-white hover:text-white transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-white/50 shrink-0" />
                <span className="text-sm text-white">{contactInfo.address}</span>
              </li>
            </ul>
          </div>

          {/* Trust */}
          <div>
            <h3 className="text-white font-medium mb-6 uppercase tracking-wider text-sm">Hvorfor vælge os?</h3>
            <p className="text-sm leading-relaxed mb-4 text-white">
              Vi er et dansk ægtepar, der selv bor i området og hjælper dig personligt fra start til slut.
            </p>
            <p className="text-sm leading-relaxed mb-4 text-white/90">
              Golf4Life tilbyder fleksible og skræddersyede golfophold i det autentiske Andalusien, hvor både korte og længere rejser er mulige. Særligt for kortere ophold er det en fordel, at selskabet kan tilpasse rejsen efter gæsternes ønsker og behov. Kombinationen af golfbaner i nærområdet, dansk repræsentation på stedet, hyggeligt socialt samvær og den spanske kultur skaber gode rammer for en afslappende og oplevelsesrig rejse. Golf4Life lægger vægt på personlig service og hjælper med at sammensætte ophold på alt fra én uge til flere ugers varighed.
            </p>
            <div className="bg-black/10 p-4 rounded-lg border border-white/5 shadow-sm">
              <p className="text-xs font-medium text-white/40 uppercase tracking-wider mb-1">Erfaring</p>
              <p className="text-sm text-white font-medium">+10 års erfaring med golfrejser</p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Golf4Life. Alle rettigheder forbeholdes.
          </p>
          <div className="flex gap-6 text-xs text-white/40">
            <a href="#" className="hover:text-white transition-colors">Privatlivspolitik</a>
            <a href="#" className="hover:text-white transition-colors">Handelsbetingelser</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
